var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/paperclip-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperclip-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.33 21.3401C11.24 21.3401 10.15 20.9301 9.32004 20.1001C7.66004 18.4401 7.66004 15.7501 9.32004 14.0901L11.8 11.6201C12.09 11.3301 12.57 11.3301 12.86 11.6201C13.15 11.9101 13.15 12.3901 12.86 12.6801L10.38 15.1501C9.31004 16.2201 9.31004 17.9701 10.38 19.0401C11.45 20.1101 13.2 20.1101 14.27 19.0401L18.16 15.1501C19.34 13.9701 19.99 12.4001 19.99 10.7301C19.99 9.06011 19.34 7.49011 18.16 6.31011C15.72 3.87011 11.76 3.87011 9.32004 6.31011L5.08004 10.5501C4.09004 11.5401 3.54004 12.8601 3.54004 14.2601C3.54004 15.6601 4.09004 16.9801 5.08004 17.9701C5.37004 18.2601 5.37004 18.7401 5.08004 19.0301C4.79004 19.3201 4.31004 19.3201 4.02004 19.0301C2.75004 17.7501 2.04004 16.0601 2.04004 14.2601C2.04004 12.4601 2.74004 10.7601 4.02004 9.49011L8.26004 5.25011C11.28 2.23011 16.2 2.23011 19.22 5.25011C20.68 6.71011 21.49 8.66011 21.49 10.7301C21.49 12.8001 20.68 14.7501 19.22 16.2101L15.33 20.1001C14.5 20.9301 13.42 21.3401 12.33 21.3401Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach-icon.52571b9fff5f2fa5a837c2f9124f9523.svg";
export { ForwardRef as ReactComponent };